// src/utils/contactPageService.js

/**
 * Send contact form data to Firebase function
 * @param {Object} formData - The form data to send
 * @returns {Promise} - The response from the Firebase function
 */
export const sendContactForm = async (formData) => {
  const functionUrl = 'https://sendcontactemail-6zbb4skvsa-ew.a.run.app';
  
  try {
    console.log('Sending contact form data to Firebase function:', functionUrl);
    
    const response = await fetch(functionUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ...formData,
        formType: 'message' // Set this form type specifically for the Contact page message form
      }),
    });
    
    const responseData = await response.json();
    
    if (!response.ok) {
      console.error('Server error:', responseData);
      throw new Error(responseData.error || 'Failed to send message');
    }
    
    console.log('Form submission successful:', responseData);
    return responseData;
  } catch (error) {
    console.error('Error sending contact form:', error);
    throw error;
  }
};

/**
 * Send callback request data to Firebase function
 * @param {Object} callbackData - The callback request data
 * @returns {Promise} - The response from the Firebase function
 */
export const requestCallback = async (callbackData) => {
  const functionUrl = 'https://sendcontactemail-6zbb4skvsa-ew.a.run.app';
  
  try {
    console.log('Sending callback request to Firebase function:', functionUrl);
    
    const response = await fetch(functionUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ...callbackData,
        formType: 'callback'
      }),
    });
    
    const responseData = await response.json();
    
    if (!response.ok) {
      console.error('Server error:', responseData);
      throw new Error(responseData.error || 'Failed to send callback request');
    }
    
    console.log('Callback request successful:', responseData);
    return responseData;
  } catch (error) {
    console.error('Error sending callback request:', error);
    throw error;
  }
};

const contactService = {
  sendContactForm,
  requestCallback
};

export default contactService;